import { createContext } from 'react';
import type { SupportedLanguage } from '@/lib/i18n/config';
import type { DateTimePreferences } from '../types';

export type DateTimePreferencesContextValue = {
  language: SupportedLanguage;
  preferences: DateTimePreferences;
};

export const DateTimePreferencesContext =
  createContext<DateTimePreferencesContextValue | null>(null);
